import React from 'react';
import PropTypes from 'prop-types';

const TagSelector = ({ dataList, onChange, values = [] }) => {
    const handleClick = tagName => {
        let newTagList;
        if (values.includes(tagName)) {
            newTagList = values.filter(tag => tag !== tagName);
        } else {
            newTagList = [...values, tagName];
        }
        onChange(newTagList);
    };

    const styles = {
        tags: {
            display: "flex",
            flexWrap: "wrap",
            gap: "0.5rem",
            marginBottom: "0.5rem",
        },
        tag: {
            display: "inline-block",
            padding: "0.5em 1.2em",
            fontSize: "1.2rem",
            borderRadius: "2em",
            background: "#f5f5f5",
            color: "#363636",
            cursor: "pointer",
            border: "1px solid #dbdbdb",
            userSelect: "none",
            transition: "background 0.2s, color 0.2s, border-color 0.2s",
            fontWeight: "bold",
        },
        tagActive: {
            background: "#3273dc",
            color: "#fff",
            borderColor: "#3273dc",
        }
    };

    return (
        <div style={styles.tags}>
            {dataList.map((data, index) => {
                const isActive = values.includes(data);
                return (
                    <span
                        key={index}
                        style={{
                            ...styles.tag,
                            ...(isActive ? styles.tagActive : {})
                        }}
                        onClick={() => handleClick(data)}
                    >
                        {data}
                    </span>
                );
            })}
        </div>
    );
};

TagSelector.propTypes = {
    onChange: PropTypes.func,
    dataList: PropTypes.array,
    values: PropTypes.array,
};

export default TagSelector;
